export const timeToLabelMap = {
  FORENOON: 'Vormittags',
  NOON: 'Mittags',
  AFTERNOON: 'Nachmittags',
  EVENING: 'Abends'
}
